<template>
    <div class="d-flex flex-column flex-row-fluid align-items-center justify-content-center text-center py-20">
        <h1 class="font-weight-boldest text-dark-75" style="font-size: 150px; line-height: 1;">
            404
        </h1>
        <h3 class="font-weight-bold mb-3">{{ $t('GENERAL.ERROR_PAGE.NOT_FOUND_TITLE') }}</h3>
        <p class="font-size-h4 font-weight-light text-muted mb-8">
            {{ $t('GENERAL.ERROR_PAGE.NOT_FOUND_TEXT') }}
        </p>
        <router-link :to="{ name: 'home' }" class="btn btn-primary font-weight-bold">
            {{ $t('GENERAL.ERROR_PAGE.BACK_HOME') }}
        </router-link>
    </div>
</template>

<script>
export default {
    name: 'NotFoundPage',
};
</script>
